import React from 'react';
import { IEventLinkDTO } from '../../../../../../api/event-links.dao';
import { makeEventLinkInfoInPopover } from '../make-event-link-info-in-popover';
import {EventLinksViewModel} from '../event-links.viewmodel';
import { LinkItemLabel } from '../../link-info/link-item-label';
import { LinkItemButtons } from '../../link-info/link-item-buttons';

type Props = {
    className?: string;
    isEventTrackerForm?: boolean;
    onDelete?: () => void;
    vm?: EventLinksViewModel;
} & IEventLinkDTO;

type LabelProps = Props & { isOpen: boolean };

const LabelWithPopover = makeEventLinkInfoInPopover<LabelProps>(LinkItemLabel);

export const EventLinkItem = (props: Props) => {

    return (
        <div className={`event_form__items-section__item-wrapper event-link__item ${props.className}`}>
            {props.isEventTrackerForm
                ? <LinkItemLabel
                        isOpen={false}
                        type={props.type}
                        label={props.label}
                        isEventTrackerForm={props.isEventTrackerForm}
                    />
                : <LabelWithPopover {...props}/>
            }
            <LinkItemButtons url={props.url} />
        </div>
    );
};
